/**
 * http://locutus.io/php/strings/number_format/
 *
 * @param number
 * @param decimals
 * @param decPoint
 * @param thousandsSep
 * @returns {string}
 */
export function numberFormat (number, decimals, decPoint, thousandsSep) {
	number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	let n = !isFinite(+number) ? 0 : +number;
	let precision = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
	let dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
	let s;

	let toFixedFix = function (n, precision) {
		if (('' + n).indexOf('e') === -1) {
			return +(Math.round(n + 'e+' + precision) + 'e-' + precision)
		} else {
			let arr = ('' + n).split('e');
			let sig = '';

			if (+arr[1] + precision > 0) {
				sig = '+';
			}
			return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + precision)) + 'e-' + precision)).toFixed(precision);
		}
	};

	s = (precision ? toFixedFix(n, precision).toString() : '' + Math.round(n)).split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '').length < precision) {
		s[1] = s[1] || '';
		s[1] += new Array(precision - s[1].length + 1).join('0');
	}

	return s.join(dec);
}

export default numberFormat;
